<div id="container">
    <input
        #inputTextHolder
        (keyup)="setCurrentText($event)"
        (input)="setCurrentText($event)"
        id="text"
        type="text"
        size="35"
        autocomplete="off"
        class="svg_editor_input" />
    <app-editor-header
        #headerComponent
        id="header"
        *ngIf="vessel"
        [vessel]="vessel"
        [selectedMimic]="selectedMimic"
        [userCanEdit]="userCanEdit"
        [rootList]="rootList"
        [mimicName]="selectedMimic?.name"
        (onSaveRequest)="handleSaveMimicRequest()"
        (onMimicSaved)="handleMimicSaved($event)"
        (onGoBack)="handleGoBack()"
        (onShowPreview)="handleShowPreview()">
    </app-editor-header>
    <main id="main" [class.lowOpacity]="!selectedMimic">
        <app-editor-navigator
            *ngIf="vessel"
            class="nav"
            [vessel]="vessel"
            [rootList]="rootList"
            [libraryList]="libraryList"
            [canCreateOrDelete]="canCreateOrDelete()"
            (onSelectMimic)="handleSelectMimic($event)"
            (onCreateMimic)="createNewMimic($event)"
            (onDeleteMimic)="deleteMimic($event)"
            (onDuplicateMimic)="duplicateMimic($event)"
            (onDeleteLibrary)="deleteLibrary($event)"
            (onDeleteCategory)="deleteLibraryCategory($event)"
            (onDeleteComponent)="deleteLibraryComponent($event)"
            (onDeleteMimicFolder)="deleteMimicFolder($event)"
            (onOpenFolderExpanded)="openFolderExpanded($event)"
            (onOpenLibraryExpanded)="openLibraryExpanded($event)"
            (onOpenComponentDialog)="closeOrientationPopup()">
        </app-editor-navigator>
        <div class="painting-container">
            <div class="locked-container">
                <app-locked-mimic-notification
                    [vessel]="vessel"
                    [rootList]="rootList"
                    (onCreateMimic)="createNewMimic($event)"></app-locked-mimic-notification>
                <div class="lock-container" *ngIf="savedSuccessful">
                    <mat-icon svgIcon="check" />
                    <div class="notification-message">
                        {{ 'mimic.page.saved.notification' | translate }}
                    </div>
                </div>
            </div>
            <div class="painting" id="svg_editor" data-cy="mimics-canvas">
                <div
                    id="workarea"
                    #workarea
                    [ngClass]="{
                        'plus-cursor': plusCursor,
                        'move-canvas': isInCanvasMoveMode,
                        'draw-mode': isInDrawMode,
                    }">
                    <style id="styleoverrides" type="text/css" media="screen" scoped="scoped"></style>
                    <div
                        #editorContainer
                        id="editorContainer"
                        (contextmenu)="editorContainerContextMenu($event)"
                        style="position: relative; height: 100%">
                        <ng-container *ngIf="orientationPopupConfig">
                            <app-orientation-popup [config]="orientationPopupConfig"></app-orientation-popup>
                        </ng-container>
                        <div class="contextmenu-container" #editorContextMenu>
                            <div
                                class="contextmenu-item"
                                *ngFor="let item of CONTEXTMENU_ITEM_LIST"
                                (click)="handleContextMenu(item.hotkey, $event)">
                                <span class="contextmenu-item-name">
                                    {{ item.name | translate }}
                                </span>
                                <span class="contextmenu-item-hotkey">
                                    {{ item.hotkey }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer class="painting-footer" *ngIf="selectedMimic && userCanEdit">
                <app-footer-buttons
                    class="footer-buttons-container"
                    [selectedMimic]="selectedMimic"></app-footer-buttons>
            </footer>
        </div>
        <app-editor-side-menu
            #sideMenu
            class="side-menu"
            [selectedMimic]="selectedMimic"
            [userCanEdit]="userCanEdit"
            [libraryList]="libraryList"
            [rootList]="rootList">
        </app-editor-side-menu>
    </main>
</div>

<ng-container *ngIf="!vessel || showLoadingSpinner">
    <app-loading-spinner class="spinner-component"></app-loading-spinner>
</ng-container>

<app-confirmation-window
    #exitMimicConfirmation
    [mainLabel]="'mimic.page.exit-confirmation.title'"
    subLabel="mimic.page.exit-confirmation.subLabel"
    [discardLabel]="'mimic.page.exit-confirmation.discard'"
    [goBackLabel]="'mimic.page.exit-confirmation.go-back'"
    [saveLabel]="'mimic.page.exit-confirmation.save'"></app-confirmation-window>

<app-confirmation-window
    #showPreviewConfirmation
    [mainLabel]="'mimic.page.show-preview-confirmation.title'"
    [subLabel]="'mimic.page.show-preview-confirmation.sub-label'"
    [discardLabel]="'mimic.page.show-preview-confirmation.discard'"
    [goBackLabel]="'mimic.page.show-preview-confirmation.go-back'"
    [saveLabel]="'mimic.page.show-preview-confirmation.save'"></app-confirmation-window>

<app-confirmation-window
    #deleteDialog
    [mainLabel]="deleteMainMessage"
    [subLabel]="deleteSubMessage"
    [goBackLabel]="deleteCancelLabel"
    [thirdLabel]="deleteThirdLabel"
    [saveLabel]="deleteConfirmLabel"
    [inverseColors]="true"
    [variant]="deleteVariant"
    (click)="$event.stopPropagation()"></app-confirmation-window>
